import React, {useContext, useState} from 'react';
import {
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import APIWrapperContext from '../../../services/APIWrapperContext';
import {DocumentsService} from '../../../services/openapi/services/DocumentsService';

interface DeleteFileProps {
  curr_dir_id: string;
  type: string;
  name: string;
  onDeleteStart?: () => void;
  onDeleteSuccess?: () => void;
  onDeleteError?: () => void;
}

export const DeleteFile: React.FC<DeleteFileProps> = ({
  curr_dir_id,
  type,
  name,
  onDeleteStart,
  onDeleteSuccess,
  onDeleteError,
}) => {
  const {call_backend_api} = useContext(APIWrapperContext);
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    // Call onDeleteStart to trigger optimistic update
    onDeleteStart?.();
    handleClose();

    call_backend_api(
      DocumentsService.deleteDocumentDocDeleteDocumentHidriveIdDelete(curr_dir_id),
      () => {
        // Call onDeleteSuccess when deletion is successful
        onDeleteSuccess?.();
      },
      () => {
        // Call onDeleteError when deletion fails
        onDeleteError?.();
      },
      undefined,
      true,
      `${type === 'file' ? 'Datei' : 'Ordner'} gelöscht!`,
      `${type === 'file' ? 'Datei' : 'Ordner'} konnte nicht gelöscht werden!`
    );
  };

  return (
    <>
      <Tooltip title='Löschen'>
        <IconButton onClick={handleClickOpen} color='error' edge='end' aria-label='delete'>
          <DeleteForeverIcon />
        </IconButton>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'>
        <DialogTitle id='alert-dialog-title'>
          {type === 'file' ? 'Datei löschen' : 'Ordner löschen'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            {type === 'file'
              ? `Möchten Sie die Datei "${name}" wirklich löschen?`
              : `Möchten Sie den Ordner "${name}" wirklich löschen?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Abbrechen</Button>
          <Button onClick={handleDelete} color='error' autoFocus>
            Löschen
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
